import { unauthedV3Request } from './requests'

/**
 *
 * /password resource requests
 *
 */

/**
 * Request a password reset email
 * POST /api/v3/password
 *
 * @param {Object} params
 * @param {string} params.email - User's email address
 * @returns {Promise} API response
 */
export const postPasswordReset =
  ({ email }) =>
    unauthedV3Request('v3/password', {
      method: 'POST',
      body: JSON.stringify({
        email,
      })
    });

/**
 * Update password using reset token
 * PUT /api/v3/password
 *
 * @param {Object} params
 * @param {string} params.password - New password
 * @param {string} params.password_confirmation - Password confirmation
 * @param {string} params.reset_password_token - Token from password reset email
 * @returns {Promise} API response
 */
export const putPasswordReset =
  ({ password, password_confirmation, reset_password_token }) =>
    unauthedV3Request('v3/password', {
      method: 'PUT',
      body: JSON.stringify({
        password,
        password_confirmation,
        reset_password_token,
      })
    });

// Backward-compatible alias for consumers still using the old name
export const patchPasswordReset = putPasswordReset;
